import {BaseApiTemplateService} from '../shared/base-api-template-service.model';
import {CashbookContainerModel} from '../../../../../models/aggregates/cashbook/cashbook-container.model';
import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Core2Config} from '../shared/core2Config';

@Injectable({providedIn: 'root'})
export class CashbookService extends BaseApiTemplateService<CashbookContainerModel> {

  constructor(http: HttpClient) {
    super();
    this.endpoint_path = Core2Config.TENANT_URL_PREFIX + Core2Config.DOMAIN_PREFIX + 'erp/cashbooks';
    this.httpClient = http;
  }
}
